
export const setUserDetail = payload => dispatch => {
    
    localStorage.setItem('pos-user', JSON.stringify(payload));

    dispatch({
        type: 'SET_USER_DETAIL',
        payload: payload
    })
}